import React from "react";
import { AlertCircle } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const CancelPurchaseDialog = ({ cancelFor, onClose, onConfirm }) => (
  <AlertDialog open={!!cancelFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><AlertCircle className="h-4 w-4 text-destructive" /> Cancel Purchase {cancelFor?.purchase_no}?</AlertDialogTitle>
        <AlertDialogDescription>This reverses the material stock added by this purchase. Only possible when no payments have been recorded.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Purchase</AlertDialogCancel>
        <AlertDialogAction className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Cancel Purchase</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const DeletePurchaseDialog = ({ deleteFor, onClose, onConfirm }) => (
  <AlertDialog open={!!deleteFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><AlertCircle className="h-4 w-4 text-destructive" /> Delete Purchase {deleteFor?.purchase_no}?</AlertDialogTitle>
        <AlertDialogDescription>This permanently removes the purchase record. Prefer Cancel for normal corrections — use Delete only to clean up an erroneous or duplicate entry. This cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Purchase</AlertDialogCancel>
        <AlertDialogAction data-testid="purchase-delete-confirm" className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Delete Purchase</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
